import {  PRICE_TO_PAY_DRIVER_FOR_ADMIN } from "../../routes";
import customAxios from "../../customAxios";

async function findDriverFactorsForAdmin({
  driverId,
  startAt,
  endAt,
}: {
  driverId: string;
  startAt?: string;
  endAt?: string;
}) {
  try {
    console.log({ startAt, endAt });

    let url = `${PRICE_TO_PAY_DRIVER_FOR_ADMIN}/${driverId}`;

    if (startAt && endAt) {
      url = url + `?startAt=${startAt}&endAt=${endAt}`;
    }

    const result = (await customAxios.get(url)).data;
    return result;
    // handle the response
  } catch (error) {
    console.log(error);
    return false;
  }
}

export default findDriverFactorsForAdmin;
